import TextField from 'components/forms/textField/TextField';
import PropertyFormFieldLabel from 'pages/property/common/PropertyFormFieldLabel';
import { useTranslation } from 'react-i18next';

const NumberOfBedsField = () => {
  const { t } = useTranslation();

  return (
    <TextField
      label={
        <PropertyFormFieldLabel name="capacityDetails.bedCount">
          {t('pageProperty.mainSettings.capacityDetails.bedCount')}
        </PropertyFormFieldLabel>
      }
      name="capacityDetails.bedCount"
      colSmInput={7}
      colSmLabel={5}
      rightTooltip={t(
        'pageProperty.mainSettings.capacityDetails.bedCountTooltip',
      )}
      disabled
    />
  );
};

export default NumberOfBedsField;
